import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import goBack from '../../actions/go-back';

export const BackButton = ({ children, className, goBack: handleClick }) =>
  <button className={className} onClick={handleClick}>
    {children}
  </button>;

BackButton.propTypes = {
  goBack: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

const mapDispatchToProps = {
  goBack,
};

export default connect(undefined, mapDispatchToProps)(BackButton);



// WEBPACK FOOTER //
// ./app/containers/back-button/back-button.js